import { Td } from '@/components/atoms/TableCells';
import { UsMetricCells } from '../ValueDashboard/us/UsMarketMetrics';
import { cn } from '@/lib/infra/utils';
import { PricePill } from '../ValueDashboard/ladder/PricePill';
import type { MarketSide, PriceMode } from '../ValueDashboard/types';
import { usLinePillCents, type UsLineCell } from './usLineCell';

/** One exact spread/total's pills, shared by compact and detailed tables. */
export function UsLinePriceCell({ cell, priceMode, marketSide, yesLabel = 'Y', noLabel = 'N', flipPills = false,
  holdOddsWidth = false, onClick }: {
  cell: UsLineCell; priceMode: PriceMode; marketSide: MarketSide; yesLabel?: string; noLabel?: string;
  flipPills?: boolean; holdOddsWidth?: boolean; onClick?: (side: MarketSide, cents: number) => void;
}) {
  return <><Td className={cn('whitespace-nowrap text-center', holdOddsWidth && 'px-1.5')}
    data-testid="us-line-cell" data-us-state={cell.state}>
    {cell.state !== 'absent' && <div className={cn('flex items-center justify-center gap-1.5', flipPills && 'flex-row-reverse')}>
      {(['yes', 'no'] as const).map(side => {
        const cents = usLinePillCents(cell, side, priceMode);
        return <PricePill key={side} label={side === 'yes' ? yesLabel : noLabel} interaction="trade" cents={cents}
          holdOddsWidth holdPriceWidth side={side} sideTint activeMarketSide={marketSide} priceMode={priceMode}
          disabled={cell.state !== 'current' || cents == null}
          disabledReason={cell.state !== 'current' ? 'no confirmed US quote (feed offline, withdrawn or not yet received)' : undefined}
          ticker={null} lt2Owner onClick={(e) => {
            e.stopPropagation();
            if (cents != null && cell.state === 'current' && cell.quote.currentAt()) onClick?.(side, cents);
          }} />;
      })}
    </div>}
  </Td><UsMetricCells slug={cell.state === 'current' || cell.state === 'listed' ? cell.quote.marketSlug : null}
    statistics={cell.state === 'current' && cell.quote.currentAt() ? cell.quote.statistics : null} /></>;
}
